import { useState, useCallback } from "react";

export interface Reflection {
  id: string;
  classId: number;
  classTitle: string;
  dateMs: number;
  date: string;
  q1: string;
  q2: string;
  q3: string;
  avgScore: number;
}

interface ReflectionStore {
  reflections: Reflection[];
}

const DEFAULT: ReflectionStore = { reflections: [] };

function load(): ReflectionStore {
  try {
    const raw = localStorage.getItem("growseo_reflections");
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.warn("ReflectionStore load error", e);
  }
  return DEFAULT;
}

function save(s: ReflectionStore) {
  try {
    localStorage.setItem("growseo_reflections", JSON.stringify(s));
  } catch (e) {
    console.warn("ReflectionStore save error", e);
  }
}

export function useReflectionStore() {
  const [data, setData] = useState<ReflectionStore>(load);

  const addReflection = useCallback((r: Omit<Reflection, "id" | "dateMs" | "date">) => {
    const now = Date.now();
    const newRef: Reflection = {
      ...r,
      id: `${now}-${Math.random().toString(36).slice(2, 6)}`,
      dateMs: now,
      date: new Date(now).toLocaleDateString("ko-KR"),
    };
    setData((prev) => {
      const next = { reflections: [newRef, ...prev.reflections] };
      save(next);
      return next;
    });
  }, []);

  const getReflectionForClass = useCallback(
    (classId: number) => data.reflections.find((r) => r.classId === classId) ?? null,
    [data.reflections]
  );

  return { reflections: data.reflections, addReflection, getReflectionForClass };
}
